import axios from 'axios';
//export const API = process.env.REACT_APP_API_URL_PRE_PROD;
export const API = process.env.REACT_APP_API_URL_PROD;
// Create an axios instance with the base URL

const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});


// Add request interceptor to include auth token if available
apiClient.interceptors.request.use(
  config => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    if (storedAuthState) {
      const parsedAuthState = JSON.parse(storedAuthState);
      if(parsedAuthState && parsedAuthState.token) {
        config.headers['Authorization'] = `Bearer ${parsedAuthState.token}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Export the API client as default
export default apiClient;
